import App from './container';

export default App;



// WEBPACK FOOTER //
// ./src/routes/Embed/App/index.js